import styles from "./Section5.module.css";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import parse from "html-react-parser";
import { useIsMobile } from "../../utils/utils";

interface RootState {
  links: {
    oliveTree: string;
    noTime: string;
  };
}

interface section5Props {
  pageData: {
    homePageData: {
      no_time: string;
    };
  };
  loading: boolean;
}

const Section5: React.FC<section5Props> = ({ pageData, loading }) => {
  const backgroundImage = useSelector(
    (state: RootState) => state.links.oliveTree
  );

  let text: React.ReactNode = (
    <Skeleton count={3} style={{ width: "300px", marginBottom: "10px" }} />
  );
  if (pageData) {
    text = <>{parse(pageData.homePageData.no_time)}</>;
  }
  const isMobile = useIsMobile();

  return (
    <div
      style={{ backgroundImage: `url(${backgroundImage})` }}
      className={styles.container}
    >
      <div className={styles.noTime}>
        <div className={styles.qute}>
          כִּ֧י אֶת־כׇּל־הָאָ֛רֶץ אֲשֶׁר־אַתָּ֥ה רֹאֶ֖ה לְךָ֣ אֶתְּנֶ֑נָּה
          וּֽלְזַרְעֲךָ֖ עַד־עוֹלָֽם:
        </div>
        <div className={styles.bodyText}>
          אחרי אלפיים שנות גלות, לפני 150 שנה החל עם ישראל לשוב אל הארץ שנתן לנו
          האל.
        </div>

        <div style={{ marginTop: "20px" }} className={styles.qute}>
          וְהָאָ֛רֶץ נִשְׁאֲרָ֥ה הַרְבֵּֽה־מְאֹ֖ד לְרִשְׁתָּֽהּ׃
        </div>
        <div className={styles.bodyText}>
          חזרנו הביתה, אך המשימה רק התחילה. רוב מרחבי ארצנו עדיין לא בידינו.
          אחרי מלחמת ששת הימים, החלו אנשי ההתיישבות לשוב בפעולה אל שטחי המולדת
          ששוחררו.
        </div>
      </div>
    </div>
  );
};

export default Section5;
